<div class="relative w-full top-0 h-[4.6rem] bg-gray-900"></div>

<div [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'">
  <div class="flex items-center justify-center mt-10 mb-14">
    <h1
      class="text-center inline-block text-lg lg:text-3xl border border-black px-5 py-1 rounded-full"
    >
      {{ equipment?.title?.[activeLang] }}
    </h1>
  </div>

  <!-- حالة الخطأ -->
  <!-- <div *ngIf="errorMsg" class="w-full flex items-center justify-center py-16">
    <div class="text-red-600">
      {{
        "loadError" | transloco : { default: "Failed to load machines." }
      }}
      ({{ errorMsg }})
    </div>
  </div> -->

  <ng-container *ngIf="!errorMsg">
    <!-- بيانات أو تحميل -->
    <ng-container *ngIf="machines$ | async as machines; else loadingTpl">
      <div
        class="px-1 lg:px-10 grid grid-cols-1 xl:grid-cols-2 items-center gap-5"
      >
        <div
          class="flex mb-10"
          *ngFor="let item of machines; trackBy: trackById"
        >
          <div class="w-1/2">
            <a [routerLink]="['/', activeLang, 'machine', item.seoURL]">
              <img
                *ngIf="item.images?.[0]?.url !== 'none'"
                class="mx-auto"
                [src]="item.images?.[0]?.url"
                loading="lazy"
                width="80%"
                [alt]="item.altText || item.name?.[activeLang]"
              />
            </a>
          </div>
          <div class="w-1/2">
            <a
              class="hover:text-[#E60027]"
              [routerLink]="['/', activeLang, 'machine', item.seoURL]"
            >
              <h2 class="mt-2 fontBold">
                {{ item.name?.[activeLang] }}
              </h2>
            </a>
            <p
              *ngIf="item.smallDes"
              [dir]="activeLang === 'AR' ? 'rtl' : 'ltr'"
            >
              {{ item.smallDes?.[activeLang] }}
            </p>
          </div>
        </div>
      </div>

      <!-- لا يوجد بيانات -->
      <div
        class="w-full flex items-center justify-center py-20"
        *ngIf="machines.length === 0"
      >
        <div class="text-gray-600">
          {{ "noResults" | transloco : { default: "No machines found." } }}
        </div>
      </div>
    </ng-container>

    <!-- سبينر التحميل -->
    <ng-template #loadingTpl>
      <div class="w-full flex items-center justify-center py-24">
        <div class="inline-flex items-center gap-3">
          <span
            class="w-6 h-6 rounded-full border-2 border-gray-300 border-t-transparent animate-spin"
          ></span>
          <span class="text-gray-600">{{
            "loading" | transloco : { default: "Loading..." }
          }}</span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>

<div class="my-60"></div>
